import { render, staticRenderFns } from "./stokListesi.vue?vue&type=template&id=57f54a1d"
import script from "./stokListesi.vue?vue&type=script&lang=js"
export * from "./stokListesi.vue?vue&type=script&lang=js"
import style0 from "./stokListesi.vue?vue&type=style&index=0&id=57f54a1d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports